import axios, { AxiosInstance, AxiosError } from 'axios';

const API_BASE_URL = (import.meta as any).env.VITE_API_BASE_URL || 'http://localhost:3000/v1';

let unauthorizedHandler: ((reason: 'SESSION_REVOKED' | 'TOKEN_EXPIRED' | 'OTHER') => void) | null = null;

export const setUnauthorizedHandler = (handler: (reason: 'SESSION_REVOKED' | 'TOKEN_EXPIRED' | 'OTHER') => void) => {
  unauthorizedHandler = handler;
};

export const createAxiosInstance = (): AxiosInstance => {
  const instance = axios.create({
    baseURL: API_BASE_URL,
    headers: {
      'Content-Type': 'application/json',
    },
  });

  // Request interceptor: attach JWT
  instance.interceptors.request.use((config) => {
    const token = localStorage.getItem('auth_token');
    if (token) {
      config.headers.Authorization = `Bearer ${token}`;
    }
    return config;
  });

  // Response interceptor: handle 401s
  instance.interceptors.response.use(
    (response) => response,
    (error: AxiosError) => {
      if (error.response?.status === 401) {
        const errorCode = (error.response?.data as any)?.error?.code;
        const reason =
          errorCode === 'SESSION_REVOKED'
            ? 'SESSION_REVOKED'
            : errorCode === 'TOKEN_EXPIRED'
              ? 'TOKEN_EXPIRED'
              : 'OTHER';

        // Clear auth state
        localStorage.removeItem('auth_token');
        localStorage.removeItem('auth_user');

        // Call handler if set
        unauthorizedHandler?.(reason);
      }
      return Promise.reject(error);
    }
  );

  return instance;
};

export const api = createAxiosInstance();

export const getAuthToken = () => localStorage.getItem('auth_token');
export const setAuthToken = (token: string) => localStorage.setItem('auth_token', token);
export const clearAuthToken = () => localStorage.removeItem('auth_token');

export const getAuthUser = () => {
  const user = localStorage.getItem('auth_user');
  return user ? JSON.parse(user) : null;
};
export const setAuthUser = (user: any) => localStorage.setItem('auth_user', JSON.stringify(user));
export const clearAuthUser = () => localStorage.removeItem('auth_user');
